import { useTheme } from "@mui/material/styles";
import { ChevronRight, Play } from "lucide-react";
import { ButtonAutoplayBoxStyle } from "./ButtonAutoplayBox.styles";
import { IconBoxStyleMobile, ProgressBoxStyleMobile } from "./ButtonAutoplayBoxMobile.styles";
import { useAutoplayProgress } from "./useAutoplayProgress";

interface ButtonAutoplayMobile {
  duration:number,
  hideCountDownButton:() => void,
  playbackStatus:string,
  startNextVideo:() => void,
  onEndAction?:() => void
}

export function ButtonAutoplayMobile({
  duration,
  hideCountDownButton,
  playbackStatus,
  startNextVideo,
  onEndAction
}:ButtonAutoplayMobile){

  const theme = useTheme();

  const progress = useAutoplayProgress({ duration, playbackStatus, startNextVideo });

  return (
    <ButtonAutoplayBoxStyle
      onClick={ () =>{
        hideCountDownButton();
        if(onEndAction && playbackStatus === "stop") { onEndAction() }
      }  } >
      <ProgressBoxStyleMobile
        id="progress-box-mobile"
        progress={ progress }
      >
        <IconBoxStyleMobile>
          { progress >= 100 ?
            <ChevronRight size={ 16 } color={ theme.customColors.textPrimaryCta }/> :
            <Play size={ 16 } color={ theme.customColors.textPrimaryCta }/>
          }
        </IconBoxStyleMobile>
      </ProgressBoxStyleMobile>
    </ButtonAutoplayBoxStyle>
  );
}
